import { DEFAULT_NEW_CONSTRUCTION_OPTIONS } from '../defaults';
import type { IsNewConstructionFilterStore } from '../Store/store';

export function getNewConstructionDescription(isNewConstruction?: IsNewConstructionFilterStore['isNewConstruction']) {
  if (isNewConstruction === null || isNewConstruction === undefined) {
    return DEFAULT_NEW_CONSTRUCTION_OPTIONS[0].name;
  }

  const newConstructionOption = DEFAULT_NEW_CONSTRUCTION_OPTIONS.find((option) => option.value === isNewConstruction);

  if (newConstructionOption?.name) {
    return newConstructionOption.name;
  }

  return DEFAULT_NEW_CONSTRUCTION_OPTIONS[0].name;
}
